import React from 'react';
import { House, Users, Calendar, FileText, Gear, QrCode, CurrencyDollar, ClipboardText } from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../lib/utils';

export function MobileNavigation({ userRole = 'parent' }) {
  const location = useLocation();
  const navigate = useNavigate();
  
  const parentNavItems = [
    { icon: House, label: 'Dashboard', path: '/dashboard' },
    { icon: Users, label: 'Players', path: '/players' },
    { icon: QrCode, label: 'Check-In', path: '/my-qr' },
    { icon: Calendar, label: 'Sessions', path: '/sessions' },
    { icon: FileText, label: 'Waivers', path: '/waivers' },
  ];
  
  const adminNavItems = [
    { icon: House, label: 'Dashboard', path: '/admin' },
    { icon: Calendar, label: 'Sessions', path: '/admin/sessions' },
    { icon: CurrencyDollar, label: 'Financials', path: '/admin/financials' },
    { icon: QrCode, label: 'Scan', path: '/scan' },
  ];
  
  const staffNavItems = [
    { icon: House, label: 'Dashboard', path: '/staff' },
    { icon: ClipboardText, label: 'Roster', path: '/staff/roster' },
    { icon: QrCode, label: 'Scan', path: '/scan' },
  ];
  
  const getNavItems = () => {
    if (userRole === 'staff') return staffNavItems;
    if (userRole === 'admin') return adminNavItems;
    return parentNavItems;
  };
  
  const navItems = getNavItems();
  
  return (
    <nav className="mobile-nav">
      <div className="flex justify-around items-center h-full px-2 sm:px-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-col items-center justify-center px-2 sm:px-3 py-2 rounded-lg transition-colors duration-200 min-w-0 flex-1",
                isActive 
                  ? "text-primary bg-primary/10" 
                  : "text-muted-foreground hover:text-foreground"
              )}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon 
                size={20} 
                weight={isActive ? 'duotone' : 'regular'} 
                className="mb-1 flex-shrink-0"
              />
              <span className="text-xs font-medium truncate w-full text-center">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}